import { MATURITY_TRANSFORMATION_ID } from '../types';

export interface MaturityPlanOption {
  name: string;
  plan_id: MATURITY_TRANSFORMATION_ID | string;
}

export const MATURITY_PLAN_OPTIONS: MaturityPlanOption[] = [
  { name: 'Choose One', plan_id: MATURITY_TRANSFORMATION_ID.NO_MATURITY },
  { name: 'Modern Networking - Networking', plan_id: MATURITY_TRANSFORMATION_ID.MODERN_NETWORKING_ID },
  { name: 'Data Modernization', plan_id: MATURITY_TRANSFORMATION_ID.DATA_MODERNIZATION_ID },
];

export const PRESENTATION_MATURITY_PLANS = MATURITY_PLAN_OPTIONS.filter(
  (opt) => opt.plan_id !== MATURITY_TRANSFORMATION_ID.NO_MATURITY && opt.plan_id !== ''
);
